var BookAppointmentFormLayout;
(function(BookAppointmentFormLayout) {
    BookAppointmentFormLayout["DEFAULT"] = "DEFAULT";
    BookAppointmentFormLayout["CHILD"] = "CHILD";
})(BookAppointmentFormLayout || (BookAppointmentFormLayout = {}));

export { BookAppointmentFormLayout };
//# sourceMappingURL=Forms.js.map
